
import styled from 'styled-components'

import FONTS from 'constants/fonts'
import COLORS from 'constants/colors'
import MEDIA from 'constants/media'

import DollarSign from 'assets/images/icons/quote/DollarSign.svg'
import Pin from 'assets/images/icons/map-pin.png'

import {
  Icon,
  Value,
} from 'components/base/Form/Input/types'

import {
  ErrorLogicProps,
  Props,
} from './types'

export const width = 460

export const InputWrap = styled.div`
  display: block;
  position: relative;
`

export const errorLogic = (props: ErrorLogicProps): boolean | undefined => !props.valid && (props.touched || !props.pristine || props.alwaysShowError)

export const errorStyles = `border: 1px solid ${COLORS.ERROR};`

export const warningLogic = (props: Props): Value | false => !props.valid && props.value

export const warningStyles = `border: 1px solid ${COLORS.WARNING};`

export const InputField = styled.input.attrs<Props>(props => ({ disabled: props.disabled }))`
  max-width: ${width}px;
  height: 48px;
  display: block;
  font-size: ${FONTS.FONTINPUTSMOBILE};
  ${({ uppercase }): string | undefined =>
    (uppercase &&
      `
      text-transform: uppercase;
    `) ||
    undefined}
  ${(props: Props): string => {
    if (errorLogic(props as ErrorLogicProps)) {
      return errorStyles
    }
    else if (warningLogic(props)) {
      return warningStyles
    }

    return 'border: 1px solid #999;'
  }}
  border-radius: 4px;
  box-shadow: inset 0px 1px 4px rgba(0, 0, 0, 0.2);
  width: 100%;
  padding: 0 10px;
  &:hover {
    box-shadow: inset 1px 2px 8px rgba(0, 0, 0, 0.02);
  }
  &:focus {
    color: #4b515d;
    ${(props: Props): string => {
    if (errorLogic(props as ErrorLogicProps)) {
      return 'outline: none;'
    }

    return `
        border: 1px solid #b8b6b6;
        box-shadow: inset 1px 2px 4px rgba(0, 0, 0, 0.01),
      0px 0px 8px rgba(0, 0, 0, 0.2);
      `
  }}
  }
  ${(props: Props): string | undefined => {
    if (props.icon) {
      const img = (props.icon === Icon.pin && Pin) || (props.icon === Icon.dollarSign && DollarSign)

      if (!img) {
        return
      }

      return `
        background-image: url(${img});
        background-repeat: no-repeat;
        background-position: left 10px center;
        background-size: 18px auto;
        padding-left: 40px;
        &:-webkit-autofill {
          padding-left: 10px;
        }
      `
    }

    return undefined
  }}
  ${({ disabled }): string | undefined =>
    (disabled &&
      `
      background-color: ${COLORS.GREYMEDIUM};
      cursor: default;
    `) ||
    undefined}
  ${MEDIA.medium`
    font-size: ${FONTS.FONTINPUTS};
  `}
`
